function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.14,4.2h0a1.45,1.45,0,0,0-1.45,1.45v.19a7.67,7.67,0,0,1,1.45-.15,7.75,7.75,0,0,1,1.45.15v-.2A1.45,1.45,0,0,0,16.14,4.2Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16,28.3a3.06,3.06,0,0,0,3-2.41c-.88.07-1.83.11-2.88.11S14,26,13.06,25.88A3,3,0,0,0,16,28.3Z",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.14,4.2h0a1.45,1.45,0,0,0-1.45,1.45v.19a7.67,7.67,0,0,1,1.45-.15,7.75,7.75,0,0,1,1.45.15v-.2A1.45,1.45,0,0,0,16.14,4.2Z",
  fill: "none"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.25,22.61l-1.9-2.7a9,9,0,0,1-1.66-5.27V13.25a7.56,7.56,0,0,0-4.6-6.95V5.64A3,3,0,0,0,16.14,2.7h0a2.94,2.94,0,0,0-2.94,2.94V6.3a7.56,7.56,0,0,0-4.6,7v1.4a8.8,8.8,0,0,1-1.67,5.26L5,22.61a.76.76,0,0,0,.11,1c.08.07,1.72,1.5,6.41,2.11a4.52,4.52,0,0,0,9,0c4.85-.6,6.52-2.06,6.6-2.14A.75.75,0,0,0,27.25,22.61Zm-12.56-17A1.45,1.45,0,0,1,16.14,4.2h0a1.45,1.45,0,0,1,1.45,1.44v.2a7.75,7.75,0,0,0-1.45-.15,7.67,7.67,0,0,0-1.45.15ZM16,28.3a3,3,0,0,1-3-2.42C14,26,15,26,16.14,26s2,0,2.88-.11A3.06,3.06,0,0,1,16,28.3Z",
  fill: "#33ba69"
});

var SvgBorderValueActiveIcon = function SvgBorderValueActiveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBorderValueActiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/border_value_active_icon.d420e7c7.svg";
export { ForwardRef as ReactComponent };